const ROLE_URLS = {
  INSERT: "/role/insert",
  GET_ALL: "/role/get_all",
  UPDATE: "/role/update",
  GET_ONE: "/role/get_one",
  DELETE: "/role/delete_one",
  GET_ALL_SELECT: "/role/get_all_select",
};

const USER_URLS = {
  INSERT: "/user/insert",
  GET_ALL: "/user/get_all",
  UPDATE: "/user/update",
  GET_ONE: "/user/get_one",
  DELETE: "/user/delete_one",
  GET_ALL_SELECT: "/user/get_all_select",
  ADMIN_RESET: "/user/admin_reset",
  GET_ALL_DOCTOR_SELECT: "/user/get_all_select_doctor_specialization",
  CHANGE_PASSWORD: "/user/user_reset",
  IMPORT_EXCEL: "",
  PROFILE_UPDATE: "/user/update_profile_img",
  GET_ONE_IMAGE: "/user/get_one_image",
  STATUS_UPDATE: "/user/update_status",
  GET_ALL_TRAINERS: "user/get_all_trainers",
};
const STATE_URLS = {
  INSERT: "/state_db/insert",
  GET_ALL: "/state_db/get_all",
  UPDATE: "/state_db/update",
  GET_ONE: "/state_db/get_one",
  DELETE: "/state_db/delete_one",
  GET_ALL_SELECT_STATES: "/state_db/get_all_select",
};

const DESIG_URLS = {
  INSERT: "/desig/insert",
  GET_ALL: "/desig/get_all",
  UPDATE: "/desig/update",
  GET_ONE: "/desig/get_one",
  DELETE: "/desig/delete_one",
  GET_ALL_SELECT: "/desig/get_all_select",
};

const LOCATION_URLS = {
  INSERT: "/locations/insert",
  GET_ALL: "/locations/get_all",
  UPDATE: "/locations/update",
  GET_ONE: "/locations/get_one",
  DELETE: "/locations/delete_one",
  GET_ALL_SELECT: "/locations/get_all_select",
};

const HOLIDAYS_URLS = {
  INSERT: "/holiday/insert",
  GET_ALL: "/holiday/get_all",
  UPDATE: "/holiday/update",
  GET_ONE: "/holiday/get_one",
  DELETE: "/holiday/delete_one",
  GET_ALL_SELECT: "/holiday/get_all_select",
  GET_ALL_UPCOMING: "holiday/get_all_upcoming",
};

const SETTINGS_URL = {
  INSERT: "/site/insert",
  GET_ALL: "/site/get_all",
  GET_ALL_SELECT_TYPES: "/site/get_all_select_const",
};

const DASHBOARD_URL = {
  GET_COUNT: "/dashboard/get_admin_cards",
  GET_ALL_TODAY: "/attendance/get_all_today",
  DASHBOARD_GET_CALENDER: "/dashboard/get_calender",
  ACCOUNTS_DASHBOARD: "/dashboard/accounts",
  TEAM_MANAGER_DASHBOARD: "/dashboard/team_manager",
  GET_TRAINEE_SCORES: "/dashboard/trainee_scores",
  GET_ALL_TRAINEE_PROJECT: "/dashboard/project_trainees",
  GET_COMPLETED_TRAINEE_PROJECT: "/dashboard/completed_project_trainees",
};

const DOC_CHECK_LIST_URLS = {
  GET_ALL: "/doc_check/get_all",
  INSERT: "/doc_check/insert",
  GET_ALL_SELECT: "/doc_check/get_all_select",
  GET_ONE: "/doc_check/get_one",
  DELETE: "/doc_check/delete_one",
  UPDATE: "/doc_check/update",
};

const ASSET_URLS = {
  GET_ALL: "/admin_asset/get_all",
  INSERT: "/admin_asset/insert",
  GET_ONE: "/admin_asset/get_one",
  DELETE: "/admin_asset/delete_one",
  UPDATE: "/admin_asset/update",
  GET_ALL_SELECT: "/admin_asset/get_all_select",
  GET_ALL_SELECT_TYPE: "/admin_asset/get_all_select_type",
};

const BANK_URLS = {
  GET_ALL_SELECT: "/admin_banks/get_all_select",
};

const ADMIN_MENU_SETTINGS_URLS = {
  GET_ALL: "/admin_menu/get_all",
  INSERT: "/admin_menu/insert",
  GET_ALL_SELECT: "/admin_menu/get_all_select",
  GET_ONE: "/admin_menu/get_one",
  DELETE: "/admin_menu/delete_one",
  UPDATE: "/admin_menu/update",
  ROLE_GET_ALL_SELECT: "/role/get_all_select",
  ROLE_GET_ALL_SELECT_LABEL: "/role/get_all_select_label",
};
const EMAIL_SETTINGS_URLS = {
  GET_ALL: "/admin_mail/get_all",
  INSERT: "/admin_mail/insert",
  GET_ONE: "/admin_mail/get_one",
  DELETE: "/admin_mail/delete_one",
  UPDATE: "/admin_mail/update",
};
const REPORT_URLS = {
  GET_ALL_ZONE: "",
  GET_ALL_SECTION: "/report/session_report",
  GET_ALL_TRAINEE_REPORT: "/report/project_wise_trainee_report",
  GET_ALL_SESSION_REPORT: "/report/project_wise",
  PROJECT_SESSION_DOWNLOAD: "",
};
const QUESTIONS_URLS = {
  GET_ALL: "/question/get_all",
  INSERT: "/question/insert",
  GET_ONE: "/question/get_one",
  DELETE: "/question/delete_one",
  UPDATE: "/question/update",
  IMPORT_EXCEL: "/question/import",
  GET_IMAGE: "/question/get_one_image",
  STATUS_UPDATE: "/question/update_status",
  UPLOAD_IMAGE: "/question/update_question_image",
  GET_ALL_SELECT_CATEGORY: "/question/get_all_select_category",
};

const QUESTIONS_PRACTICE_URLS = {
  GET_ALL: "/questions_practical/get_all",
  INSERT: "/questions_practical/insert",
  GET_ONE: "/questions_practical/get_one",
  DELETE: "/questions_practical/delete_one",
  UPDATE: "/questions_practical/update",
  GET_ALL_SELECT_CATEGORY: "/questions_practical/get_all_select_with_cat",
};

const AGENCY_URLS = {
  GET_ALL: "/agency/get_all",
  INSERT: "/agency/insert",
  GET_ONE: "/agency/get_one",
  DELETE: "/agency/delete_one",
  UPDATE: "/agency/update",
  GET_ALL_SELECT: "/agency/get_all_select",
  GET_IMAGE: "agency/get_one_image",
};
const PRACTICAL_URLS = {
  GET_ALL: "/questions_practical/get_all",
  INSERT: "/questions_practical/insert",
  GET_ONE: "/questions_practical/get_one",
  DELETE: "/questions_practical/delete_one",
  UPDATE: "/questions_practical/update",
  GET_ALL_SELECT: "/category/get_all_select",
};

const SESSION_URLS = {
  GET_ALL: "/sessions/get_all",
  GET_ALL_TRAINER: "/sessions/get_all_trainer",
  INSERT: "/sessions/insert",
  GET_ONE: "/sessions/get_one",
  DELETE: "/sessions/delete_one",
  SESSION_START: "/sessions/start_session",
  GET_PDF: "/sessions/get_pdf",
  GET_TRAINEE_PDF: "/sessions/get_trainee_pdf",
  GET_TRAINEE: "sessions/get_trainees",
  GET_SESSIONS_BY_DATE:"sessions/get_all_session_date",
  UPDATE_SESSION_DATE: "/sessions/update_date",
  // session users
  GET_USER_GET_ONE: "/sessions/get_one_user",
  GET_ALL_USERS: "/sessions/get_all_user",
  INSERT_USER: "/sessions/insert_session_user",
  OTP_GENERATE: "/sessions/regenerate_otp",
  DELETE_USER: "/sessions/delete_user",
  CHANGE_DATE: "/sessions/change_date",
  CANCEL_SESSION: "/sessions/cancel",
  GET_TRAINEE_REPORT: "/sessions/trainee_report",
  RESENT_OTP: "/sessions/regenerate_otp",
  IMPORT_EXCEL: "/sessions/import_excel",
  GET_PRACTICE_SESSION: "/sessions/get_practice_questions",
  INSERT_PRACTICE_SESSION: "/sessions/insert_update_practical_data",
 GET_TRAINEE_CRITIFICATE: "/sessions/get_certificate",
  VERIFY_CERTIFICATE: "/sessions/check_cert",
  UPDATE_ATTENDANCE: "/sessions/update_user_status",
  UPDATE_SESSION_USER: "/sessions/update_session_user",
};

const ZONE_REPORT_URLS = {
  GET_ALL: "",
  INSERT: "",
  GET_ALL_SELECT: "",
  GET_ONE: "",
  DELETE: "",
  UPDATE: "",
};
const EXAM_URLS = {
  GET_SESSION: "/exam/get_session",
  START_EXAM: "/exam/start_exam",
  GET_QUESTIONS: "/exam/get_questions",
  OPTION_UPDATE: "/exam/option_update",
  SUBMIT_EXAM: "/exam/submit_exam",
  SUBMIT_FEEDBACK: "/exam/submit_feedback",
  GET_TRANSLATED_QUESTION:"exam/get_translated_questions"
};
const RATINGS_URLS = {
  GET_ALL: "/exam/get_all_feedback",
  INSERT: "",
  GET_ONE: "",
  DELETE: "",
  UPDATE: "",
};
export {
  ADMIN_MENU_SETTINGS_URLS,
  AGENCY_URLS,
  ASSET_URLS,
  BANK_URLS,
  DASHBOARD_URL,
  DESIG_URLS,
  DOC_CHECK_LIST_URLS,
  EMAIL_SETTINGS_URLS,
  EXAM_URLS,
  HOLIDAYS_URLS,
  LOCATION_URLS,
  QUESTIONS_URLS,
  RATINGS_URLS,
  REPORT_URLS,
  ROLE_URLS,
  SESSION_URLS,
  SETTINGS_URL,
  STATE_URLS,
  USER_URLS,
  ZONE_REPORT_URLS,
  QUESTIONS_PRACTICE_URLS,
  PRACTICAL_URLS,
};
